<template>
  <div class="print-pdf unit container edit-user-unit-container">
    <div class="pdf-background-img-container">
      <div class="pdf-background-image"></div>
    </div>
    <div class="contentSection">
      <div v-if="isFetching" class="pa-8 text-center">
        <v-progress-circular indeterminate size="28" class="mr-2" />
        Loading mission…
      </div>
      <div v-else-if="prevMission">
        <div class="">
          <div class="close-link" @click="closebuilder">
            <v-icon>arrowleft</v-icon>
            <span class="close-link-text">BACK TO EDIT MISSION</span>
          </div>
        </div>
        <div>
          <div class="unit-meta-container">
            <div class="mb-0 mt-4">
              <h2
                id="unit-title"
                class="base-year"
                v-html="prevMission.title"
              ></h2>
            </div>
          </div>

          <v-flex
            xs12
            v-for="(week, index) in localizedWeeks"
            :key="index"
          >
            <div class="unit-meta-container">
              <div class="mb-0 mt-4">
                <h2
                  id="unit-title"
                  class="base-year"
                  v-html="getWeekTitle(week)"
                ></h2>
              </div>
              <div class="mb-7 mt-0">
                <span
                  class="font-weight-bold"
                  v-html="getWeekSubtitle(week)"
                ></span>
              </div>
            </div>

            <div id="mission" class="break-page-after">
              <div class="flex-container">
                <div class="font-weight-bold text-h6 base-year">MISSION</div>
                <v-divider class="dashed" style="margin-top: 15px"></v-divider>
              </div>

              <div
                v-if="week.missionBodyContent"
                v-html="week.missionBodyContent"
                class="print-content-container mb-7 mt-3"
              ></div>

              <PreviewStudyQuestions
                :unitbackdoor="unitbackdoor"
                :content="week.missionStudyQuestions"
                section="missionStudyQuestions"
              />
            </div>

            <div id="supplication" class="break-page-after">
              <div class="flex-container">
                <div class="font-weight-bold text-h6 base-year">
                  SUPPLICATION
                </div>
                <v-divider class="dashed" style="margin-top: 15px"></v-divider>
              </div>

              <UserVersesQuotes
                :content="week.supplicationVerseQuotes"
                section="supplicationVerseQuotes"
              />

              <v-divider
                v-if="week.supplicationVerseQuotes"
                class="dashed"
              ></v-divider>

              <div
                v-if="week.supplicationBodyContent"
                v-html="week.supplicationBodyContent"
                class="print-content-container mb-7 mt-3"
              ></div>

              <PreviewStudyQuestions
                :unitbackdoor="unitbackdoor"
                :content="week.supplicationStudyQuestions"
                section="supplicationStudyQuestions"
              />
            </div>
          </v-flex>
        </div>
      </div>
      <div v-else>No Unit to preview.</div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { mapGetters } from 'vuex'
  import PreviewStudyQuestions from '@/components/utilities/PreviewStudyQuestions'
  import UserVersesQuotes from '@/components/utilities/UserVersesQuotes'
  import { hydratePreviewFromRoute } from '@/helpers/previewBridge'

  export default {
    name: 'PreviewMission',
    components: {
      PreviewStudyQuestions,
      UserVersesQuotes,
    },
    data() {
      return {
        feedback: null,
        unitbackdoor: 0,
        backdoor: 0,
        listenConfirmed: null,
        completeConfirmed: null,
        continueConfirmed: null,
        isFetching: false,
        fetchDelay: 500,
      }
    },
    computed: {
      ...mapState('UserData', ['user']),
      ...mapState('AppData', ['userActiveCourse', 'prevMission']),
      ...mapGetters('AppData', ['getCourse', 'getActiveCourse']),
      ...mapGetters('UserData', ['getRoles']),
      requiredLanguage() {
        return this.prevMission?.requiredLanguage || 'en'
      },
      localizedWeeks() {
        const weeks = this.prevMission?.selectedWeeks || []
        return weeks.map((week) => this.getLocalizedWeek(week))
      },
    },
    methods: {
      init() {
        this.unitbackdoor++
      },
      closebuilder() {
        window.close()
      },
      versesQuotesChild(value) {
        // update the property with any Study Questions
        if (value.section == 'truthVersesQuotes') {
          if (value.versesquotes.length)
            this.prevWeek.truthVersesQuotes = value.versesquotes
          else this.prevWeek.truthVersesQuotes = []
        }
      },
      getLocalizedWeek(week) {
        if (!week) return week
        const lang = this.requiredLanguage || 'en'
        const lc =
          (week.localizedContent && week.localizedContent[lang]) ||
          (lang === 'pt' && week.pt ? week.pt : null)
        if (!lc) return week

        const merged = { ...week }
        const textFields = [
          'title',
          'subtitle',
          'missionBodyContent',
          'supplicationBodyContent',
        ]
        textFields.forEach((field) => {
          if (typeof lc[field] === 'string' && lc[field].trim() !== '') {
            merged[field] = lc[field]
          }
        })

        const arrayFields = [
          'missionStudyQuestions',
          'supplicationStudyQuestions',
          'supplicationVerseQuotes',
        ]
        arrayFields.forEach((field) => {
          if (Array.isArray(lc[field]) && lc[field].length > 0) {
            merged[field] = lc[field]
          }
        })

        return merged
      },
      getWeekTitle(week) {
        return week?.title || ''
      },
      getWeekSubtitle(week) {
        return week?.subtitle || ''
      },
    },
    async created() {
      this.isFetching = true
      const delay = new Promise((res) => setTimeout(res, this.fetchDelay))
      const load = hydratePreviewFromRoute({
        route: this.$route,
        store: this.$store,
        type: 'mission',
      })
      await Promise.all([load, delay])
      this.isFetching = false
      this.init()
    },
  }
</script>

<style scoped>
  [v-cloak] {
    display: none;
  }
  #mission
    :deep(p, )
    #supplication
    :deep(p, )
    #mission
    :deep(img, )
    #supplication
    :deep(img) {
    page-break-inside: avoid;
    break-inside: avoid;
    padding-top: 16px;
    padding-bottom: 12px;
    margin-bottom: 0px;
  }

  .print-content-container,
  .study-question-statement {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .unit.container {
    max-width: 800px;
    margin-left: 10%;
  }
  .unit.container .background-img-container {
    position: fixed;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
  .unit.container .pdf-background-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: url(../../assets/mountains_bw.jpg) no-repeat 50% 0;
    background-size: cover;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  .theme--dark .unit.container .background-image {
    filter: grayscale(100%) blur(0px) invert(1);
  }
  .pdf-background-image-donotuse:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.85);
  }
  .unit .contentSection {
    position: relative;
  }
  .edit-user-unit-container.blueYear :deep(a) {
    color: #002b45;
  }
  .edit-user-unit-container.redYear :deep(a) {
    color: #6e273d;
  }
  .edit-user-unit-container.greenYear :deep(a) {
    color: #024731;
  }
  .flex-this {
    display: flex;
  }
  .edit-user-unit-container :deep(img) {
    max-width: 100%;
  }
  @media only screen and (max-width: 767px) {
    .flex-this {
      flex-direction: column;
    }
  }
</style>
